"use client";
import AppLayout from "../../templates/AppLayout";
import PrivacyOrganism from "../../organisms/Privacypolicy/index";

const PrivacyPolicyPage = () => {
  return (
    <AppLayout>
      <main className="bg-background text-on-surface font-body">
        <PrivacyOrganism />
      </main>
    </AppLayout>
  );
};

export default PrivacyPolicyPage;
